<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header" class="trip-history-header">
            <strong>Trip History</strong>
          </div>
            <b-row class="trip-filter-panel">
              <b-col md="6" lg="3">
                    <b-form-group label="From Date:" label-for="trip-from-date" class="trip-filter-group">
                    <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                    </v-date-picker>
                    </b-form-group>
              </b-col>
             

              <b-col md="6" lg="3">
                <b-form-group label="To Date:" label-for="trip-to-date" class="trip-filter-group">
                  <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }' v-model='selectDateTo'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
              
               <b-col md="6" lg="3">
                <b-form-group label="Vehicle No.:" label-for="trip-vehicle" class="trip-filter-group">
                  <v-select v-model="selected_Vehicle" @input="trip_history_Listing" :options="vehicleListing"
                    placeholder="-- Search Vehicle --" :clearable="true"></v-select>
                </b-form-group>
              </b-col>

              <b-col md="6" lg="3" v-if="usertype==1">
                <b-form-group label="Hub Name:" label-for="trip-hub" class="trip-filter-group">
                  <v-select v-model="selected_Hub" @input="selectsearchhub(selected_Hub)" :options="hubListing"
                    placeholder="-- Select Hub --"></v-select>
                </b-form-group>
              </b-col>

              <b-col cols="12" :lg="usertype==1?12:3" class="trip-filter-actions">
                  <b-button type="submit" class="trip-filter-button" variant="primary" @click="trip_history_Listing()"><i class="fa fa-search mr-1"></i> Search</b-button>
                  <b-button class="trip-filter-button" variant="success" @click="downloadLoadWiseTripReport"><i class="fa fa-download mr-1"></i> Load Wise Trip Report</b-button>
                  <b-button class="trip-filter-button" variant="outline-danger" @click="clearData"><i class="fa fa-refresh mr-1"></i> Clear</b-button>
              </b-col>

            </b-row>

            <b-col md="12" class="text-right mt-2">
                <p > <b>Total Records :<span style="color:red;">{{totalRows}}</span></b> </p>
            </b-col>

            <b-col md="12">
              <b-table show-empty responsive   :items="tripItems" :busy="isBusy"    :current-page="currentPage"  :fields="tripfields" :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" > 
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div> 
                <template slot="action" slot-scope="row">
                  <b-button
                    size="sm"
                    @click="EwaybillList(row.item)"
                  >
                    <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                  </b-button>
                </template>
                <template slot="trip_action" slot-scope="row">
                  <a :href="loadurl" target="_blank" class="ml-3">
                    <b-button variant="primary"  size="sm" @click="DownloadTripSheet(row.item)"> <i class="fa fa-download" aria-hidden="true"></i>
                    </b-button>
                  </a>
                </template>
                <template slot="numberplate_img_url" slot-scope="row">
                  <div>
                    <b-button variant="light" style="padding: 1px 6px;" :title="row.item.vehicle_no" @click="showvehicleimage(row.item)">
                      <i class="fa fa-eye" aria-hidden="true"></i>
                    </b-button>
                  </div>
                </template>
              </b-table>
            </b-col>

            <b-row>
              <b-col md="6" class="my-1" v-if="totalRows>20">
                <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      class="my-0"
                    ></b-pagination>
            
              </b-col> 
            </b-row>
          
            <b-modal v-model="openmodels" hide-footer title="Eway Bill Details" size="xl">
              <div class="d-block text-center">
                <b-col md="12" class="text-right">
                <p > <b>Total Records :<span style="color:red;">{{ewaytotalRows}}</span></b> </p>
              </b-col>

              <b-table show-empty responsive   :items="ewaybillitem" :busy="isBusyeway"    :current-page="ewaycurrentPage"  :fields="ewayfields" :per-page="ewayperPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"      :bordered="bordered" :tbody-tr-class="rowClass" >
                  <div slot="table-busy" class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                  </div> 
                  <!-- <template slot="ewaybillpdf" slot-scope="row">
                    <div>
                    <a :href="row.item.ewaybillpdf" v-if="!row.item.wms_invoice_url" target="_blank"><b-button size="sm"> <i class="fa fa-download" aria-hidden="true"></i>
                      Download Eway Bill</b-button></a>
                      <b-button v-if="row.item.wms_invoice_url && row.item.ebn" size="sm" @click="downloadEwayBill(row.item)"> <i class="fa fa-download" aria-hidden="true"></i>
                        Download Consolidated Eway Bill</b-button>
                    </div>
                  </template> -->
                  <template slot="ewaybillpdf" slot-scope="row">
                    <a :href="row.item.ewaybillpdf" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                  </template>
                  <template slot="ebn" slot-scope="row">
                    {{ ewayNumber(row.item) || '-' }}
                  </template>
                  <template slot="ewaybill_file" slot-scope="row">
                    <!-- {{ row.item.ewaybill_file }} - {{ row.item.ebn }} -->
                    <span v-if="(isRtoShipment(row.item) && ewayNumber(row.item)) || ((row.item.ewaybill_file||row.item.taxilla_ewaybill_doc) && ewayNumber(row.item))">
                      <a :href="isRtoShipment(row.item) ? row.item.ewaybillpdf : (row.item.ewaybill_file?row.item.ewaybill_file:row.item.taxilla_ewaybill_doc)" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span>
                    <!-- <span v-if="!row.item.ewaybill_file && row.item.ebn">
                      <a :href="`https://prod-1.e-waybill.in/api/e-waybill/print?ewaybill=${row.item.ebn}&html-detail=true`" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span> -->
                    <i class="fa fa-times" aria-hidden="true" v-if="!row.item.ewaybill_file && !ewayNumber(row.item)" style="color:red;font-size:x-large;"></i>
                  </template>
                  <template slot="wms_invoice_url" slot-scope="row">
                    <span v-if="row.item.wms_invoice_url" class="">
                      <!-- <i class="fa fa-check" aria-hidden="true"  style="color:green;font-size:x-large;"></i> -->
                      <a :href="row.item.wms_invoice_url" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span>
                    <i class="fa fa-times" aria-hidden="true" v-if="!row.item.wms_invoice_url" style="color:red;font-size:x-large;"></i>
                  </template>
                  <template slot="transport_doc" slot-scope="row">
                    <span v-if="row.item.transport_doc">
                      <!-- <i class="fa fa-check" aria-hidden="true"  style="color:green;font-size:x-large;"></i> -->
                      <a :href="row.item.transport_doc" target="_blank" class="ml-3"><i class="fa fa-download" aria-hidden="true" style="color:blue;font-size:x-large;"></i></a>
                    </span>
                    <i class="fa fa-times" aria-hidden="true" v-if="!row.item.transport_doc" style="color:red;font-size:x-large;"></i>
                  </template>
                  <template slot="taxilla_ewaybill" slot-scope="row">
                    <span v-if="row.item.ebn && !isRtoShipment(row.item)">
                      <i class="fa fa-download" aria-hidden="true" title="Taxilla Eway Bill" style="color:blue;font-size:x-large;" @click="downloadDirectTaxillaEwayBill(row.item)"></i>
                    </span>
                    
                  </template>
                  
                </b-table>

                <b-row>
                <b-col md="6" class="my-1" v-if="ewaytotalRows>20">
                  <b-pagination
                        v-model="ewaycurrentPage"
                        :total-rows="ewaytotalRows"
                        :per-page="ewayperPage"
                        class="my-0"
                      ></b-pagination>
              
                </b-col> 
              </b-row>
              </div>
              <b-button class="mt-3 float-right" variant="danger" @click="hideModal">Close</b-button>
            </b-modal>

            <b-modal size="lg" v-model="vehicleimg" :title="`Vehicle No.` + ' - ' + vehicleimgitem.vehicle_no" hide-footer>
              <div id="listloader" v-if="loader">
                  <div class="listloader"></div>
              </div>
              <div class="text-center mb-3">
                <span v-if="vehicleimgitem.numberplate_img_url">
                  <img :src="vehicleimgitem.numberplate_img_url" alt="Vehicle Image" style="width: 100%;">
                </span>
                <span v-else>
                  Vehicle Image Not Found
                </span>
              </div>
            </b-modal>
        </b-card>
       </b-col>
     </b-row>
   </div>
</template>
<script>
  import CONSTANTS from '@/utils/constants'
  import Utils from '@/utils'
  import Vue from 'vue'
  export default {
    data: function() {
      return {
        usertype :'',
        tripItems:[],
        isBusy:false,
        currentPage:1,
        tripfields:[
                  { key: 'tripid', label: 'Trip Id', sortable: true},
                  { key: 'vehicle_no', label: 'Vehicle No.', sortable: true},
                  { key: 'hub_title', label:'Hub Name',sortable: true},
                  { key: 'totalloads', label: 'Total Loads', sortable: true},          
                  { key: 'totalboxes', label: 'Total Boxes', sortable: true },    
                  { key: 'vehicleweightcarrying', label: 'Vehicle Capacity', sortable: true },
                  { key: 'vehiclephysicalweight', label: 'Vehicle Physical Weight', sortable: true },
                  { key: 'createddate', label: 'Created Date', sortable: true },
                  { key: 'startdate', label: 'Start Date', sortable: true },
                  { key: 'startlatlong', label: 'Start LatLong', sortable: true },
                  { key: 'numberplate_img_url', label: 'Vehicle No. Plate Image', sortable: true },
                  { key: 'tripenddate', label: 'End Date', sortable: true },
                  { key: 'endlatlong', label: 'End LatLong' },
                  { key: 'loadweight', label: 'Loads Physical Weight' },
                  { key: 'loadvolumetricweight', label: 'Loads Volumetric Weight' },
                  { key: 'action', label: 'Download Eway Bill' },
                  { key: 'trip_action', label: 'Download Trip Sheet'},
        ],
        perPage:20,
        filter:null,
        sortBy:null,
        sortDesc:false,
        sortDirection:'asc',
        bordered:true,
        totalRows:0,
        selectDateFrom: new Date(),
        selectDateTo:new Date(),
        openmodels : false,
        ewaybillitem :[],
        ewayfields : [
          {key:'parentawb', label : 'Parent AWB'},
          {key:'ebn', label : 'EBN'},
          {key:'invoiceno', label : 'Invoice No'},
          // {key:'ewaybillpdf', label : 'Eway Bill PDF'}
          {key:'ewaybill_file', label: 'Ewaybill'},
          {key:'ewaybillpdf', label: '365 Ewaybill'},
          {key:'wms_invoice_url', label: 'Invoice'},
          {key:'transport_doc', label: 'Transport Doc'},
          {key:'taxilla_ewaybill', label: 'Taxilla Ewaybill'},
         
          
        ],
        ewaytotalRows :'',
        ewayperPage:20,
        ewaycurrentPage:1,
        isBusyeway : false,
        hub_listing :[],
        hubListing :[],
        selected_Hub :'',
        selected_Vehicle :'',
        vehicleListing :[],
        loadurl:'',

        vehicleimg:false,
        vehicleimgitem:[]
      }
    },

    created: function() {
      var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        this.usertype = userInfo.user_type;
      this.hubDataList();
      this.trip_history_Listing();
    },

    methods: {
      hubDataList(){
        var userdata = localStorage.getItem("userData");
        var userInfo = JSON.parse(userdata);
        const Obj={
          sysusermasterid:`${userInfo.sysusermasterid}`,
          usertype:`${userInfo.user_type}`,
        }
        this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getAllHubListing`,Obj).then((result)=>{
            
            if (result.body.returnmsg === 'Successful') {
              var hub_listing = result.body.returnvalue;
              console.log("hub_listing",hub_listing)

              for (let i = 0; i < hub_listing.length; i++) {
                var HubDetails = hub_listing[i].hubname + "-"+ hub_listing[i].hubid;
                this.hubListing.push(HubDetails)
              }
              console.log("hub listing",this.hubListing)
            }else{
              this.hubListing=[];
            }
        })
      },

      selectsearchhub(value_hub) {
        if(value_hub ==null){
          this.selected_Hub="";
          this.trip_history_Listing();
        }
      },

      trip_history_Listing(){
      this.currentPage=1;
        this.isBusy=true;
        var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          var fromdate = (this.selectDateFrom!=null)?this.formatDate(this.selectDateFrom):"";
          var formatdateto=(this.selectDateTo!=null)? this.formatDate(this.selectDateTo):"";
          var selecthub_id = this.selected_Hub !=""?this.selected_Hub.split("-"):this.selected_Hub;
          var selecthub_idpass = selecthub_id[1]==undefined?null:selecthub_id[1]
          console.log("selecthub_id",selecthub_id[1])

          const Obj={
            fromdate:fromdate,
            todate:formatdateto,
            sysusermasterid:`${userInfo.sysusermasterid}`,
            hub_id :`${userInfo.hub_id}`,
            serviceid :selecthub_idpass,
            user_type : `${userInfo.user_type}`,
            vehicle_no : this.selected_Vehicle || null,
          }
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getDistinctTripDetails`,Obj).then((result)=>{
              // console.log("Result",result);
              this.isBusy=false;
              if (result.body.returnmsg === 'Successful') {
                this.tripItems=result.body.returnvalue;
                this.vehicleListing = Array.from(new Set(result.body.returnvalue
                  .map(item => item.vehicle_no).filter(Boolean))).sort();
                this.totalRows=result.body.returnvalue.length;
              }else{
                this.tripItems=[];
                this.totalRows=0;
              }
          })
      },

      downloadLoadWiseTripReport(){
        if(!this.selectDateFrom || !this.selectDateTo){ Vue.toasted.error('From Date and To Date are mandatory'); return; }
        const u=JSON.parse(localStorage.getItem('userData')); const h=this.selected_Hub?this.selected_Hub.split('-')[1]:null;
        this.$http.post(CONSTANTS.MIGRATION_API_URL+'/dwonoadreportcsv',{fromdate:this.formatDate(this.selectDateFrom),todate:this.formatDate(this.selectDateTo),vehicle_no:this.selected_Vehicle||null,hub_id:h,sysusermasterid:u.sysusermasterid},{responseType:'blob'}).then(r=>{const url=window.URL.createObjectURL(new Blob([r.data],{type:'text/csv'})); const a=document.createElement('a'); a.href=url; a.download='load-wise-trip-report.csv'; document.body.appendChild(a); a.click(); document.body.removeChild(a); window.URL.revokeObjectURL(url);});
      },

      clearData(){
          this.selectDateFrom=new Date();
          this.selectDateTo=new Date();
          this.selected_Hub="";
          this.selected_Vehicle="";
          this.vehicleListing=[];
          this.trip_history_Listing();
      },

      formatDate: function(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
        return [year, month, day].join("-");

      },

      hideModal : function(){
        this.openmodels = false;
      },

      EwaybillList : function (value) {
      console.log("value-----------------",value);
        this.ewaycurrentPage =1;
        this.ewaybillitem=[];
        this.ewaytotalRows=0;
        this.openmodels=true;
        this.isBusyeway=true;
        var userdata = localStorage.getItem("userData");
          var userInfo = JSON.parse(userdata);
          const Obj={
            tripid :value.tripid,
            hub_id :value.hub_id
          }
          console.log("obj",Obj)
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/getEwaybillListAndDownloadNew`,Obj).then((result)=>{
              console.log("Result",result);
              this.isBusyeway=false;
              if (result.body.returnmsg === 'Successful') {
                this.ewaybillitem=result.body.returnvalue;
                console.log("ewaybillitem",this.ewaybillitem)
                this.ewaytotalRows=result.body.returnvalue.length;
              }else{
                this.ewaybillitem=[];
                this.ewaytotalRows=0;
              }
          })
      },

      isRtoShipment(item){
        return !!item && (String(item.shipmentstatus || '').toUpperCase().indexOf('RTO') === 0 || !!item.rto_ewaybill_no);
      },
      ewayNumber(item){
        return item && (this.isRtoShipment(item) ? item.rto_ewaybill_no : item.ebn);
      },
      rowClass(item){
        return this.isRtoShipment(item) ? 'table-warning' : '';
      },
      downloadEwayBill(data){
          const payload = Object.assign({}, data, { ebn: this.ewayNumber(data) });
          this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadConsolidatedEwaybill`,payload)
          .then(result=>{
            // console.log('result---------->',result)
            const base64String = result.data;
            const binaryString = window.atob(base64String);
            const uint8Array = new Uint8Array(binaryString.length);
            for (let i = 0; i < binaryString.length; i++) {
                uint8Array[i] = binaryString.charCodeAt(i);
            }
            const blob = new Blob([uint8Array], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            window.open(url, '_blank');
          })
          .catch(error=>{
            console.log('error------------>',error)
            this.$fire({text:'Error In Downloading Consolidated E-way Bill!',type: "error",timer: 30000})
          })
      },
      DownloadTripSheet(value){
        this.loadurl=`${CONSTANTS.MIGRATION_API_URL}/generateTripSummaryPdf?tripid=`+value.tripid;
      },
      showvehicleimage: function (data){
            this.vehicleimg = true;
            this.vehicleimgitem =[];
            this.vehicleimgitem = data;
        },

      downloadDirectTaxillaEwayBill(item){
        // document.getElementById("overlay").style.display = "block";
         let doc_Obj={
          ebn:`${item.ebn}`,
          awb:`${item.parentawb}`
         }
         this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/downloadDirectEwayBillFromTaxilla`,doc_Obj).then((response)=>{
          // document.getElementById("overlay").style.display = "none";
         if(response.body.returnmsg =='Successful'){
          let url = response.body.returnvalue;
          window.open(url, '_blank');
          // this.dailyTrip(this.selected_status);
         }else{
          this.$fire({text:'Error In Download',type: "error",timer: 30000})
         }
                
         }).catch(err=>{
          console.error('err------------------->',err);
          this.$fire({text:'Error In Download',type: "error",timer: 30000})
          document.getElementById("overlay").style.display = "none";
         })
      }
    },
   
  };
</script>
<style scoped>
  .trip-history-header {
    color: #2f3c4e;
    font-size: 16px;
  }

  .trip-filter-panel {
    margin: 0 0 18px;
    padding: 18px 12px 6px;
    border: 1px solid #e4e9f0;
    border-radius: 6px;
    background: #f8fafc;
  }

  .trip-filter-group {
    margin-bottom: 14px;
  }

  .trip-filter-group label {
    display: block;
    margin-bottom: 6px;
    color: #4a5568;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: .02em;
  }

  .trip-filter-group .form-control,
  .trip-filter-group .dateInput,
  .trip-filter-group .v-select .vs__dropdown-toggle {
    min-height: 38px;
    border-color: #d5dce5;
    border-radius: 4px;
    background: #fff;
  }

  .trip-filter-group .dateInput {
    width: 100%;
    padding: 7px 10px;
  }

  .trip-filter-group .v-select {
    height: 38px;
    min-height: 38px;
    font-size: 14px;
  }

  .trip-filter-group .v-select .vs__dropdown-toggle {
    height: 38px;
    padding: 0 8px;
    display: flex;
    align-items: center;
  }

  .trip-filter-group .v-select .vs__selected-options {
    min-width: 0;
    align-items: center;
    flex-wrap: nowrap;
  }

  .trip-filter-group .v-select .vs__selected,
  .trip-filter-group .v-select .vs__search,
  .trip-filter-group .v-select .vs__search::placeholder {
    margin: 0;
    padding: 0 3px;
    line-height: 36px;
    color: #4a5568;
  }

  .trip-filter-group .v-select .vs__search {
    min-width: 50px;
  }

  .trip-filter-group .v-select .vs__actions {
    height: 36px;
    padding: 0 2px;
    display: flex;
    align-items: center;
  }

  .trip-filter-group .v-select .vs__clear,
  .trip-filter-group .v-select .vs__open-indicator {
    fill: #718096;
  }

  .trip-filter-actions {
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 8px;
    padding-top: 19px;
    padding-bottom: 14px;
  }

  .trip-filter-button {
    min-height: 38px;
    white-space: nowrap;
  }

  @media (max-width: 991.98px) {
    .trip-filter-actions {
      justify-content: flex-start;
      padding-top: 0;
    }
  }
</style>
